/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumDesktopPermission {
	Default = 'default',
	Granted = 'granted',
	Denied 	= 'denied'
}
